import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const deliveryPersonAPI = createApi({
    reducerPath: "deliveryPersonAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllDeliveryPersonWithoutPage: builder.query({
            query: ({orderId}) => {
                let apiUrl = `admin/data/delivery-person`;

                if(orderId){
                    apiUrl += `?orderId=${orderId}`
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["all_deliveryPerson"],
        }),
        getAllDeliveryPerson: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/delivery-person?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["deliveryPerson"],
        }),
        getSpecificDeliveryPersonDetails: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/delivery-person/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createDeliveryPerson: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/delivery-person",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["deliveryPerson"],
        }),
        updateDeliveryPerson: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/delivery-person`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["deliveryPerson"],
        }),
        deleteDeliveryPerson: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `admin/delivery-person/${id}`,
                    method: "DELETE"
                };
            },
            invalidatesTags: ["deliveryPerson"],
        })
    })
});

export const { 
    useGetAllDeliveryPersonWithoutPageQuery,
    useGetAllDeliveryPersonMutation,
    useGetSpecificDeliveryPersonDetailsMutation,
    useCreateDeliveryPersonMutation,
    useUpdateDeliveryPersonMutation,
    useDeleteDeliveryPersonMutation
} = deliveryPersonAPI;

export default deliveryPersonAPI;